export enum ItemStatus {
  Declined = -6,
  Expired = -3,
  Draft = 0,
  Approved = 3,
  Kept = 6
}
